import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/common/button/Button";
import TextField from "../../../components/common/textfield/TextField";
import logo from "../../../assets/images/AO-logo-black.jpg";
import { routeNames } from "../../../consts/routesNames";
import { ValidateEmail, ValidateFields } from "../../../utils/formValidation";
import { passwordResetCheckEmail } from "../../../apis/authenticationApis/passwordResetCheckEmail";
import "./ForgotPasswordCheckEmail.css";

function ForgotPasswordCheckEmail() {
  const [emailState, setEmailState] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!ValidateFields(emailState)) {
      alert("The Email field is required");
      return;
    }
    if (!ValidateEmail(emailState)) {
      alert("Wrong Email Format.");
      return;
    }

    const response = await passwordResetCheckEmail(emailState);
    if (response.error_code === 1) {
      navigate(routeNames.FORGOT_PASSWORD_RESET, {
        state: { email: emailState },
      });
    } else {
      alert(response.error_message);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="forgot-password-body-container">
        <div className="forgot-password-main-container">
          <img className="forgot-password-logo" src={logo} alt="" />
          <div className="forgot-password-card-container">
            <div className="forgot-password-labeltext-main-container">
              <div className="forgot-password-labeltext-container">
                <TextField
                  label={"Email"}
                  name="email"
                  type="email"
                  setValue={setEmailState}
                  value={emailState}
                  placeHolder="Please Enter Your Email ...."
                  isRequired={true}
                  maxLength={100}
                  autoComplete="email"
                />
              </div>
              <div className="forgot-password-buttons-container">
                <div className="forgot-password-button-container">
                  <Button
                    className="login"
                    buttonText={"Continue"}
                    type="submit"
                  />
                </div>
              </div>
              <div className="forgot-password-link-container">
                <button
                  className="forgot-password-link-button"
                  type="button"
                  onClick={() => navigate(routeNames.LOGIN)}
                >
                  Back to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default ForgotPasswordCheckEmail;
